<template>
  <div id="divNominatingAuth" style="font-size: small !important">
    <div class="Flex_Table tblEntryForm">
      <fieldset class="EntryBlock">
        <legend>
          <div class="Flex_Table tblEntryForm" style="width: 100%">
            <div class="Flex_Row">
              <div
                class="Flex_Cell"
                style="width: 24%"
                v-if="PaymentStatus != 1"
              >
                <span>Master Account</span>
                <SearchDropDown
                  v-bind:list-data="MasterAccount_List"
                  value-field="masterAccountID"
                  text-field="commonName"
                  v-model="masterAccountID"
                  first-item="-- Select --"
                  style="width: 100%"
                  title="Select Nominating Authority"
                  @change="fillMasterData(masterAccountID)"
                ></SearchDropDown>
              </div>
              <div class="Flex_Cell" valign="bottom" style="width: 26%">
                <input
                  type="button"
                  id="btnAdd"
                  name="btnAdd"
                  btnName="btnAdd"
                  value="Add"
                  @click="addEditMaster(1)"
                  v-if="PaymentStatus != 1"
                  style="padding: 5px 30px; margin-left: 10px"
                  title="Click here to Add as new"
                />
                <input
                  type="button"
                  id="btnEdit"
                  name="btnEdit"
                  btnName="btnEdit"
                  value="Edit"
                  @click="addEditMaster(2)"
                  style="padding: 5px 30px; margin-left: 10px"
                  title="Click here to update"
                  v-if="masterAccountID != -1 && PaymentStatus != 1"
                />
              </div>
              <div
                class="Flex_Cell"
                style="width: 50%"
                valign="bottom"
                align="right"
              >
                <div class="Flex_Table tblEntryForm">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      align="right"
                      valign="bottom"
                      v-if="PaymentStatus != 1"
                      style="width: 40%"
                    >
                      <AcceptInput
                        maxlength="6"
                        style="padding-left:0 padding-right:0; width:100px"
                        ref="captcha"
                        type="textbox"
                        v-model="captchaValue"
                        :isRequired="true"
                        placeholder="CAPTCHA"
                        class="CreateAccount"
                        regExp="([0-9])*"
                      />&nbsp;&nbsp;
                      <img
                        id="imgCaptcha"
                        style="border: 1px solid #000"
                      />&nbsp;&nbsp;
                      <img
                        src="../assets/images/refresh.png"
                        v-on:click="generateCaptcha(1, 110, 21)"
                        style="
                          cursor: pointer;
                          height: 20px;
                          border: 1px solid #000;
                          border-radius: 50%;
                        "
                        title="Click here to refresh captcha"
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      align="right"
                      valign="bottom"
                      style="width: 60%"
                    >
                      <input
                        type="button"
                        id="btnSave"
                        name="btnSave"
                        btnName="btnSave"
                        :value="btnSave"
                        style="padding: 5px 15px 5px 15px"
                        :title="btnSaveMsg"
                        v-if="PaymentStatus != 1"
                        @click="saveNomAuth()"
                      />
                      <input
                        type="button"
                        id="btnCancel"
                        name="btnCancel"
                        btnName="btnCancel"
                        :value="btnCancel"
                        style="padding: 5px 15px 5px 15px"
                        :title="btnCancelMsg"
                        @click="clear()"
                      />
                    </div>
                  </div>
                </div>

                <!-- <input
              type="button"
              id="btnAdd"
              name="btnAdd"
              btnName="btnAdd"
              value="Go Back"
              @click="goBack()"
              style="padding: 5px 30px; margin-left: 10px"
              title="Click here to Add as new"
            /> -->
              </div>
            </div>
          </div>
        </legend>
        <div class="Flex_Table tblEntryForm">
          <div class="Flex_Row RowHeight">
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Ref No."
                description="ENTER REFERENCE NO."
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Ref No."
                  v-model="refNo"
                  disabled
                  maxlength="256"
                  regExp="([a-zA-Z/0-9])*"
                  title="ENTER REFERENCE NO."
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 7%">
              <BlockInput
                label="Title"
                description="SELECT TITLE"
                :isRequired="false"
              >
                <SearchDropDown
                  v-bind:list-data="TitleList"
                  value-field="titleID"
                  text-field="titleName"
                  v-model="titleID"
                  style="width: 100%"
                  title="SELECT TITLE"
                ></SearchDropDown>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 18%">
              <BlockInput
                label="First Name"
                description="ENTER FIRST NAME"
                :isRequired="true"
              >
                <AcceptInput
                  :isRequired="true"
                  placeholder="First Name"
                  v-model="fName"
                  maxlength="256"
                  regExp="([a-zA-Z])*"
                  title="ENTER FIRST NAME"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Middle Name"
                description="ENTER MIDDLE NAME"
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Middle Name"
                  v-model="mName"
                  maxlength="256"
                  regExp="([a-zA-Z])*"
                  title="ENTER MIDDLE NAME"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Last Name"
                description="ENTER LAST NAME"
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Last Name"
                  v-model="lName"
                  maxlength="256"
                  regExp="([a-zA-Z])*"
                  title="ENTER LAST NAME"
                />
              </BlockInput>
            </div>
          </div>
          <div class="Flex_Row RowHeight">
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Bank Name"
                description="ENTER BANK NAME"
                :isRequired="true"
              >
                <!-- <SearchDropDown
                  v-bind:list-data="bank_list"
                  value-field="bankID"
                  text-field="bankName"
                  v-model="bankID"
                  first-item="--Select--"
                  style="width: 100%"
                  title="ENTER BANK"
                  @change="getNoCC(bankID)"
                ></SearchDropDown> -->
                <BankMasterList
                  v-model.trim="bankID"
                  id="goNosSearch3"
                  @reset="bankID = -1"
                  @enter="getNoCC(bankID)"
                ></BankMasterList>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Branch Name"
                description="ENTER BRANCH NAME"
                :isRequired="true"
              >
                <AcceptInput
                  :isRequired="true"
                  placeholder="Branch Name"
                  v-model="branchName"
                  maxlength="256"
                  regExp="([a-zA-Z \-])*"
                  title="ENTER BRANCH NAME"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: true }"
                >Designation
              </span>
              <!-- <BlockInput
                label="Designation"
                description="ENTER DESIGNATION NAME"
                :isRequired="true"
              > -->
              <!-- <SearchDropDown
                  v-bind:list-data="DesigList"
                  value-field="desigID"
                  text-field="desigName"
                  v-model="desigID"
                  first-item="--Select--"
                  style="width: 100%"
                  title="ENTER DESIGNATION"
                ></SearchDropDown> -->
              <DesignationMasterList
                v-if="userTypeID != -1"
                v-model="desigID"
                id="serDesignation"
                title="SELECT DESIGNATION"
                @reset="desigID = -1"
              ></DesignationMasterList>
              <!-- </BlockInput> -->
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Letter No."
                description="ENTER LETTER NO."
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Letter No."
                  v-model="letterNo"
                  maxlength="200"
                  regExp="([a-zA-Z0-9\.\,\_\-\/\(\)])*"
                  title="ENTER LETTER NO."
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Contact No. [C.C./A.C./Contact No.]"
                description="ENTER CONTACT NO."
                :isRequired="true"
              >
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="true"
                        placeholder="C.C."
                        class="CountryCode"
                        v-model="contactCC"
                        maxlength="3"
                        regExp="([+0-9])*"
                        title="ENTER C.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="true"
                        placeholder="A.C."
                        v-model="contactAC"
                        maxlength="3"
                        regExp="([0-9])*"
                        title="ENTER A.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="
                        width: 60% !important;
                        padding-right: 0px;
                        padding-left: 0px;
                      "
                    >
                      <AcceptInput
                        :isRequired="true"
                        placeholder="Contact No."
                        v-model="contactNo"
                        maxlength="10"
                        regExp="([0-9])*"
                        title="ENTER CONTACT NO."
                      />
                    </div>
                  </div>
                </div>
              </BlockInput>
            </div>

            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Mobile No. [C.C./Mobile No.]"
                description="ENTER MOBILE NO."
                :isRequired="true"
              >
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="true"
                        placeholder="C.C."
                        v-model="mobileCC"
                        maxlength="5"
                        regExp="([+0-9])*"
                        title="ENTER C.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="
                        width: 80% !important;
                        padding-right: 0px;
                        padding-left: 0px;
                      "
                    >
                      <AcceptInput
                        :isRequired="true"
                        placeholder="Mobile No."
                        v-model="mobileNo"
                        :maxlength="mobileCC == '+91' ? '10' : '20'"
                        regExp="([0-9])*"
                        title="ENTER MOBILE NO."
                      />
                    </div>
                  </div>
                </div>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Email-ID"
                description="ENTER EMAIL"
                :isRequired="true"
              >
                <AcceptInput
                  :isRequired="true"
                  placeholder="Email-ID"
                  v-model="emailID"
                  maxlength="200"
                  type="email"
                  regExp="([a-zA-Z0-9\@\.\_\-])*"
                  title="ENTER EMAIL"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Fax No. [C.C./A.C./Fax No.]"
                description="ENTER FAX NO."
                :isRequired="false"
              >
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="C.C."
                        v-model="faxCC"
                        maxlength="3"
                        regExp="([+0-9])*"
                        title="ENTER C.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="A.C."
                        v-model="faxAC"
                        maxlength="3"
                        regExp="([0-9])*"
                        title="ENTER A.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="
                        width: 60% !important;
                        padding-right: 0px;
                        padding-left: 0px;
                      "
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="Fax No."
                        v-model="faxNo"
                        maxlength="10"
                        regExp="([0-9])*"
                        title="ENTER FAX NO."
                      />
                    </div>
                  </div>
                </div>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Alternate No. [C.C./A.C./Contact No.]"
                description="ENTER ALTERNATE CONTACT NO."
                :isRequired="false"
              >
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="C.C."
                        v-model="altContactCC"
                        maxlength="3"
                        regExp="([+0-9])*"
                        title="ENTER C.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="A.C."
                        v-model="altContactAC"
                        maxlength="3"
                        regExp="([0-9])*"
                        title="ENTER A.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="
                        width: 60% !important;
                        padding-right: 0px;
                        padding-left: 0px;
                      "
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="Alternate Contact No."
                        v-model="altContactNo"
                        maxlength="10"
                        regExp="([0-9])*"
                        title="ENTER ALTERNATE CONTACT NO."
                      />
                    </div>
                  </div>
                </div>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="WhatsApp No. [C.C./WhatsApp No.]"
                description="ENTER WHATSAPP NO."
                :isRequired="false"
              >
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="C.C."
                        v-model="altMobileCC"
                        maxlength="3"
                        regExp="([+0-9])*"
                        title="ENTER C.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="
                        width: 80% !important;
                        padding-right: 0px;
                        padding-left: 0px;
                      "
                    >
                      <AcceptInput
                        :isRequired="false"
                        placeholder="WhatsApp No."
                        v-model="altMobileNo"
                        maxlength="10"
                        regExp="([0-9])*"
                        title="ENTER WHATSAPP NO."
                      />
                    </div>
                  </div>
                </div>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Alternate Email-ID"
                description="ENTER ALTERNATE EMAIL"
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Alternate Email-ID"
                  v-model="altEmail"
                  maxlength="200"
                  type="email"
                  regExp="([a-zA-Z0-9\@\.\_\-])*"
                  title="ENTER ALTERNATE EMAIL"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Address 1"
                description="ENTER ADDRESS 1"
                :isRequired="true"
              >
                <AcceptTextArea
                  :isRequired="true"
                  placeholder="Address 1"
                  v-model="address1"
                  maxlength="300"
                  regExp="([a-zA-Z0-9\.\ \,\_\-\/\(\)])*"
                  title="ENTER ADDRESS 1"
                />
              </BlockInput>
            </div>
          </div>
          <div class="Flex_Row RowHeight">
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Address 2"
                description="ENTER ADDRESS 2"
                :isRequired="false"
              >
                <AcceptTextArea
                  :isRequired="false"
                  placeholder="Address 2"
                  v-model="address2"
                  maxlength="300"
                  regExp="([a-zA-Z0-9\.\ \,\_\-\/\(\)])*"
                  title="ENTER ADDRESS 2"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Remark"
                description="ENTER REMARK"
                :isRequired="false"
              >
                <AcceptTextArea
                  :isRequired="false"
                  placeholder="Remark"
                  v-model="remark"
                  maxlength="300"
                  regExp="([a-zA-Z0-9\.\,\_\-\/\(\) ])*"
                  title="ENTER REMARK"
                />
              </BlockInput>
            </div>
          </div>
        </div>
        <legend>CONTACT PERSON DETAILS</legend>
        <div class="Flex_Table tblEntryForm">
          <div class="Flex_Row RowHeight">
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Contact Person Name"
                description="ENTER Contact Person Name"
              >
                <AcceptInput
                  :isRequired="true"
                  placeholder="Contact Person Name"
                  v-model="contactPersonName"
                  regExp="([a-zA-Z0-9 \&\-\,\.])*"
                  title="Contact Person Name"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span>Designation </span>
              <DesignationMasterList
                v-if="userTypeID != -1"
                v-model="contactPersondesigID"
                id="serDesignation1"
                title="SELECT DESIGNATION"
                @reset="contactPersondesigID = -1"
              ></DesignationMasterList>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Contact Person Department"
                description="ENTER Contact Person Department"
              >
                <AcceptInput
                  :isRequired="true"
                  placeholder="Contact Person Drepartment"
                  v-model="contactPersonDepartment"
                  regExp="([a-zA-Z0-9])*"
                  title="Contact Person Name"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Mobile No. [C.C./Mobile No.]"
                description="ENTER MOBILE NO."
              >
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        placeholder="C.C."
                        v-model="contactCC"
                        maxlength="5"
                        regExp="([+0-9])*"
                        title="ENTER C.C."
                      />
                    </div>
                    <div
                      class="Flex_Cell"
                      style="
                        width: 80% !important;
                        padding-right: 0px;
                        padding-left: 0px;
                      "
                    >
                      <AcceptInput
                        placeholder="Mobile No."
                        v-model="contactPersonMobNoCC"
                        :maxlength="contactCC == '+91' ? '10' : '20'"
                        regExp="([0-9])*"
                        title="ENTER MOBILE NO."
                      />
                    </div>
                  </div>
                </div>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Mobile No. [A.C./Mobile No.]"
                description="ENTER MOBILE NO."
              >
                <div class="Flex_Table">
                  <div class="Flex_Row">
                    <!-- <div
                      class="Flex_Cell"
                      style="width: 20% !important; padding-left: 0px"
                    >
                      <AcceptInput
                        placeholder="A.C."
                        v-model="contactPersonMobNoAC"
                        maxlength="5"
                        regExp="([+0-9])*"
                        title="ENTER A.C."
                      />
                    </div> -->
                    <div
                      class="Flex_Cell"
                      style="
                        width: 100% !important;
                        padding-right: 0px;
                        padding-left: 0px;
                      "
                    >
                      <AcceptInput
                        placeholder="Mobile No."
                        v-model="contactPersonMobNoAC"
                        :maxlength="contactPersonMobNoAC == '+91' ? '10' : '20'"
                        regExp="([0-9])*"
                        title="ENTER MOBILE NO."
                      />
                    </div>
                  </div>
                </div>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Email-ID"
                description="ENTER EMAIL"
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Email-ID"
                  v-model="contactPersonEmail"
                  maxlength="200"
                  type="email"
                  regExp="([a-zA-Z0-9\@\.\_\-])*"
                  title="ENTER Email"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput label="Address" description="ENTER ADDRESS">
                <AcceptTextArea
                  :isRequired="true"
                  placeholder="Address"
                  v-model="contactPersonAddress"
                  maxlength="300"
                  regExp="([a-zA-Z0-9\.\ \,\_\-\/\(\)])*"
                  title="ENTER ADDRESS"
                />
              </BlockInput>
            </div>
          </div>
        </div>
        <legend>PAYING AUTHORITY</legend>
        <div class="Flex_Table tblEntryForm">
          <div class="Flex_Row RowHeight">
            <!-- <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Bank Name"
                description="ENTER BANK NAME"
                :isRequired="true"
              >
               <SearchDropDown
                  v-bind:list-data="pBank_list"
                  value-field="bankID"
                  text-field="bankName"
                  v-model="pBankID"
                  first-item="--Select--"
                  style="width: 100%"
                  title="ENTER BANK"
                  disabled
                ></SearchDropDown>
                <BankMasterList
                  v-model.trim="pBankID"
                  id="goNosSearch3"
                  disabled
                ></BankMasterList>
              </BlockInput>
            </div> -->
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="State Name"
                description="ENTER STATE NAME"
                :isRequired="true"
              >
                <SearchDropDown
                  v-bind:list-data="pState_list"
                  value-field="stateID"
                  text-field="stateName"
                  v-model="pStateID"
                  first-item="--Select--"
                  style="width: 100%"
                  title="SELECT STATE"
                ></SearchDropDown>
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="GST No."
                description="ENTER GST NO."
                :isRequired="true"
              >
                <AcceptInput
                  :isRequired="true"
                  placeholder="GST No."
                  v-model="pGSTNo"
                  maxlength="15"
                  @input="val => (pGSTNo = pGSTNo.toUpperCase())"
                  regExp="([a-zA-Z0-9])*"
                  title="ENTER GST NO."
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Paying Authority Name"
                description="ENTER PAYING AUTHORITY NAME"
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Paying Authority Name"
                  v-model="payingAuthName"
                  maxlength="50"
                  regExp="([a-zA-Z0-9 \&\-\,\.])*"
                  title="ENTER PAYING AUTHORITY NAME"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <span class="mandatorySpan" :class="{ Required: false }">
                Designation
              </span>
              <!-- <BlockInput
                label="Designation"
                description="ENTER DESIGNATION"
                :isRequired="false"
              > -->
              <!-- <SearchDropDown
                  v-bind:list-data="DesigList"
                  value-field="desigID"
                  text-field="desigName"
                  v-model="pDesigID"
                  first-item="--Select--"
                  style="width: 100%"
                  title="SELECT DESIGNATION"
                ></SearchDropDown> -->

              <Designation1MasterList
                v-if="userTypeID != -1"
                v-model="pDesigID"
                id="serDesignation1"
                title="SELECT DESIGNATION"
                @reset="pDesigID = -1"
                disabled
              ></Designation1MasterList>
              <!-- </BlockInput> -->
            </div>
          </div>
          <div class="Flex_Row RowHeight">
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Email-ID"
                description="ENTER EMAIL"
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Email-ID"
                  v-model="pEmail"
                  maxlength="200"
                  type="email"
                  regExp="([a-zA-Z0-9\@\.\_\-])*"
                  title="ENTER Email"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Contact No."
                description="ENTER CONTACT NO."
                :isRequired="false"
              >
                <AcceptInput
                  :isRequired="false"
                  placeholder="Contact No."
                  v-model="pContactNo"
                  maxlength="10"
                  regExp="([0-9])*"
                  title="ENTER CONTACT NO."
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="City"
                description="ENTER CITY"
                :isRequired="true"
              >
                <AcceptInput
                  :isRequired="true"
                  placeholder="City"
                  v-model="pCity"
                  maxlength="100"
                  regExp="([a-zA-Z0-9 \,\/\(\)])*"
                  title="ENTER CITY"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Pin Code"
                description="ENTER PIN CODE"
                :isRequired="true"
              >
                <AcceptInput
                  :isRequired="true"
                  placeholder="Pin Code"
                  v-model="pPinCode"
                  maxlength="6"
                  regExp="([0-9])*"
                  title="ENTER PIN CODE"
                />
              </BlockInput>
            </div>
          </div>
          <div class="Flex_Row RowHeight">
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Address"
                description="ENTER ADDRESS"
                :isRequired="true"
              >
                <AcceptTextArea
                  :isRequired="true"
                  placeholder="Address"
                  v-model="pAddress"
                  maxlength="300"
                  regExp="([a-zA-Z0-9 \.\,\_\-\/\(\)])*"
                  title="ENTER ADDRESS"
                />
              </BlockInput>
            </div>
            <div class="Flex_Cell" style="width: 25%">
              <BlockInput
                label="Place of Supply"
                description="ENTER PLACE OF SUPPLY"
                :isRequired="true"
              >
                <AcceptTextArea
                  :isRequired="true"
                  placeholder="Place of Supply"
                  v-model="pPlaceOfSupply"
                  maxlength="300"
                  regExp="([a-zA-Z0-9 \.\ \,\_\-\/\(\)])*"
                  title="ENTER PLACE OF SUPPLY"
                />
              </BlockInput>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import Router from "vue-router";
import AcceptInput from "./ekkControls/AcceptInput";
import AcceptTextArea from "./ekkControls/AcceptTextArea";
import SearchDropDown from "./ekkControls/SearchDropDown";
import CheckDropDown from "./ekkControls/CheckDropDown";
import ModalPopup from "./ekkControls/ModalPopup";
import Tab from "./ekkControls/Tab";
import BlockInput from "./ekkControls/BlockInput";
import DateControl from "./ekkControls/DateControl";
import OnOff from "./ekkControls/OnOff";
import AppJS from "./serviceJS/applicationJS.js";
import NomAuthJS from "./serviceJS/NomineeAuth.js";
import LoginJS from "./serviceJS/loginjs.js";
import BankMasterList from "./usercontrols/BankMasterList.vue";
import DesignationMasterList from "./usercontrols/DesignationMasterList.vue";
import Designation1MasterList from "./usercontrols/Designation1MasterList.vue";

// import ng2 from "ng2-tele-input";

export default {
  name: "Application",
  props: {
    TitleList: { required: true },
    NomAuthList: { required: true },
    userTypeID: { required: true },
    ProgID: { required: true },
    NomAuthID: { required: true },
    ModeOfExecution: { required: true },
    PaymentStatus: { required: true }
  },
  components: {
    DateControl: DateControl,
    AcceptInput: AcceptInput,
    AcceptTextArea: AcceptTextArea,
    SearchDropDown: SearchDropDown,
    CheckDropDown: CheckDropDown,
    ModalPopup: ModalPopup,
    Tab: Tab,
    BlockInput: BlockInput,
    OnOff: OnOff,
    BankMasterList: BankMasterList,
    DesignationMasterList: DesignationMasterList,
    Designation1MasterList: Designation1MasterList
  },
  data() {
    return {
      //===============Naminating Authority Derails=================
      progID: -1,
      refNo: "",
      title_List: [],
      titleID: 1,
      fName: "",
      mName: "",
      lName: "",
      bank_list: [],
      bankID: -1,
      branchName: "",
      desig_list: [],
      desigID: -1,
      discount: "0",
      contactNo: "",
      contactCC: "+91",
      contactAC: "",
      altContactNo: "",
      altContactCC: "+91",
      altContactAC: "",
      mobileNo: "",
      mobileCC: "+91",
      altMobileNo: "",
      altMobileCC: "+91",
      faxNo: "",
      faxCC: "+91",
      faxAC: "",
      emailID: "",
      altEmail: "",
      letterNo: "",
      address1: "",
      address2: "",
      remark: "",
      //============================================================
      //=================Paying Authority Details===================
      pBank_list: [],
      pBankID: -1,
      pState_list: [],
      pStateID: -1,
      pGSTNo: "",
      payingAuthName: "",
      pEmail: "",
      pAddress: "",
      pContactNo: "",
      pDesig_list: [],
      pDesigID: -1,
      pPlaceOfSupply: "",
      pCity: "",
      pPinCode: "",
      //============================================================
      btnSave: "Save",
      btnSaveMsg: "Click Here to Save",
      btnCancel: "Clear",
      btnCancelMsg: "Click Here to Clear",
      confirmationDiv: false,
      MasterAccount_List: [],
      masterAccountID: -1,
      selectedNomAuth: [],
      Nomination_List: [],
      NomineeID: -1,

      captchaValue: "",
      captchaKey: "",

      //==============Contact Person Details =========================

      contactPersonName: "",
      contactPersondesigID: -1,
      contactPersonDepartment: "",
      contactPersonMobNoCC: "",
      contactPersonMobNoAC: "",
      contactPersonEmail: "",
      contactPersonAddress: ""
    };
  },
  methods: {
    // CheckGSTNo(value) {
    //   // if (
    //   //   /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value)
    //   // ) {
    //   if (
    //     /^([0-9]{2})*([A-Z]{5})*([0-9]{4})*([A-Z]{1})*([0-9A-Z]{1})*Z*([0-9A-Z]{1})+$/.test(
    //       value
    //     )
    //   ) {
    //   } else {
    //     this.pGSTNo = "";
    //     MessageBox.show({
    //       message: "PLEASE ENTER CORRECT GST NO.",
    //       type: "error",
    //       title: "Error",
    //     });
    //     return;
    //   }
    // },
    CheckEmailOrMob(value) {
      if (this.mobileCC == "+91") {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(value)) {
          return "E";
        } else if (/^[3456789]\d{9}$/.test(value) && value.length == 10) {
          return "M";
        }
      } else {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(value)) {
          return "E";
        } else if (value.length < 21) {
          return "M";
        }
      }
    },
    modalPopupShown(e) {},
    modalPopupClosed(e) {},
    getNoCC(bankID) {
      var CC = this.bank_list.filter(r => {
        return r.bankID == bankID;
      })[0].countryISDCode;
      this.contactCC = CC;
      this.altContactCC = CC;
      this.mobileCC = CC;
      this.altMobileCC = CC;
      this.faxCC = CC;
      // this.pBankID = bankID;
    },
    GetBank() {
      const _data_ = { BankID: -1, type: 1 };
      AppJS.GetBank(_data_).then(
        response => {
          if (response.data) {
            this.bank_list = response.data;
            // this.pBank_list = response.data;
          }
        },
        error => {}
      );
    },
    GetState() {
      const _data_ = { CountryID: -1, StateID: -1 };
      AppJS.GetState(_data_).then(
        response => {
          if (response.data) {
            this.pState_list = response.data;
          }
        },
        error => {}
      );
    },
    saveNomAuth() {
      if (this.checkPrams(this.fName) == true) {
        MessageBox.show({
          message: "PLEASE ENTER FIRST NAME",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.checkPrams(this.bankID) == true) {
        MessageBox.show({
          message: "SELECT BANK NAME",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.checkPrams(this.branchName) == true) {
        MessageBox.show({
          message: "SELECT BRANCH NAME",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.checkPrams(this.desigID) == true) {
        MessageBox.show({
          message: "SELECT DESIGNATION",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (
        this.checkPrams(this.contactCC) == true &&
        this.checkPrams(this.contactAC) == true &&
        this.checkPrams(this.contactNo) == true
      ) {
        MessageBox.show({
          message: "PLEASE ENTER CONTACT NO.",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (
        this.checkPrams(this.mobileCC) == true &&
        this.checkPrams(this.mobileNo) == true
      ) {
        MessageBox.show({
          message: "PLEASE ENTER MOBILE NO.",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.CheckEmailOrMob(this.mobileNo) != "M") {
        MessageBox.show({
          message: "PLEASE ENTER VALID MOBILE NO.",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.checkPrams(this.emailID) == true) {
        MessageBox.show({
          message: "PLEASE ENTER EMAIL",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.CheckEmailOrMob(this.emailID) != "E") {
        MessageBox.show({
          message: "PLEASE ENTER VALID EMAIL",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.checkPrams(this.address1) == true) {
        MessageBox.show({
          message: "PLEASE ENTER ADDRESS 1",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.discount == "") {
        MessageBox.show({
          message: "PLEASE ENTER DISCOUNT OR 0%",
          type: "error",
          title: "Error"
        });
        return;
      }
      // if (this.checkPrams(this.pBankID) == true) {
      //   MessageBox.show({
      //     message: "SELECT BANK (PAYING AUTHORITY)",
      //     type: "error",
      //     title: "Error",
      //   });
      //   return;
      // }
      if (this.checkPrams(this.pStateID) == true) {
        MessageBox.show({
          message: "SELECT STATE (PAYING AUTHORITY)",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.checkPrams(this.pGSTNo) == true) {
        MessageBox.show({
          message: "PLEASE ENTER GST No. (PAYING AUTHORITY)",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.checkPrams(this.pAddress) == true) {
        MessageBox.show({
          message: "PLEASE ENTER ADDRESS (PAYING AUTHORITY)",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.checkPrams(this.pPlaceOfSupply) == true) {
        MessageBox.show({
          message: "PLEASE ENTER PLACE OF SUPPLY (PAYING AUTHORITY)",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.checkPrams(this.pCity) == true) {
        MessageBox.show({
          message: "PLEASE ENTER CITY (PAYING AUTHORITY)",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.checkPrams(this.pPinCode) == true) {
        MessageBox.show({
          message: "PLEASE ENTER PIN CODE (PAYING AUTHORITY)",
          type: "error",
          title: "Error"
        });
        return;
      }
      if (this.checkPrams(this.captchaValue) == true) {
        MessageBox.show({
          message: "PLEASE ENTER CAPTCHA",
          type: "error",
          title: "Error"
        });
        return;
      }
      // if (this.masterAccountID == -1) {
      //   this.confirmationDiv = false;
      //   this.SetOnlineNominee(0);
      // } else {
      //   this.confirmationDiv = true;
      // }
      if (
        this.btnSave == "Save As Master" ||
        this.btnSave == "Update As Master"
      ) {
        this.showMessageBox1();
      } else if (this.btnSave == "Save" || this.btnSave == "Update") {
        if (this.masterAccountID == -1) {
          this.showMessageBox();
        } else {
          this.showMessageBox2();
        }
      }
    },
    yesClick() {
      this.SetOnlineNominee(1);
    },
    noClick() {
      this.SetOnlineNominee(0);
    },
    showMessageBox2() {
      MessageBox.show(
        {
          message: "Are you sure to save?",
          type: "confirm",
          title: "",
          defaultButton: 3
        },
        {
          buttonName: "Yes",
          buttonAction: this.noClick
        },
        { buttonName: "Cancel", buttonAction: this.clear }
      );
    },
    showMessageBox1() {
      MessageBox.show(
        {
          message: "Are you sure to save?",
          type: "confirm",
          title: "",
          defaultButton: 3
        },
        {
          buttonName: "Yes",
          buttonAction: this.SetOnlineMasterData
        },
        { buttonName: "Cancel", buttonAction: this.clear }
      );
    },
    showMessageBox() {
      MessageBox.show(
        {
          message: "Do you want to Save as Master also?",
          type: "confirm",
          title: "",
          defaultButton: 3
        },
        {
          buttonName: "Yes",
          buttonAction: this.yesClick
        },
        {
          buttonName: "No",
          buttonAction: this.noClick
        },
        { buttonName: "Cancel", buttonAction: this.clear }
      );
    },
    checkPrams(_param) {
      var _isError = false;
      if (
        _param == "" ||
        _param == -1 ||
        _param == null ||
        _param == 0 ||
        _param == "01 Jan 1900"
      ) {
        _isError = true;
      }
      if (_isError) {
        return _isError;
      }
    },
    SetOnlineMasterData() {
      const _data_ = {
        MasterAccountID: this.masterAccountID,
        LoginTypeID: this.userTypeID,
        UserMobileCC: this.mobileCC,
        UserMobile: this.mobileNo,
        UserEMail: this.emailID,
        RankID: this.titleID,
        FName: this.fName,
        MName: this.mName,
        LName: this.lName,
        GenderID: -1,
        DOB: new Date("01 JAN 1900"),
        BankID: this.bankID,
        BranchName: this.branchName,
        Organization: "",
        DesigID: this.desigID,
        GSTNo: this.pGSTNo,
        PFNo: "",
        Scale: "",
        EmployeeNo: "",
        Address1: this.address1,
        Address2: this.address2,
        AlternateMobileNoCC: this.altMobileCC,
        AlternateMobileNo: this.altMobileNo,
        AlternateEmail: this.altEmail,
        ContactNoCC: this.contactCC,
        ContactNoAC: this.contactAC,
        ContactNo: this.contactNo,
        AlternateContactNoCC: this.altContactCC,
        AlternateContactNoAC: this.altContactAC,
        AlternateContactNo: this.altContactNo,
        FaxCC: this.faxCC,
        FaxAC: this.faxAC,
        Fax: this.faxNo,
        IsActive: 1,
        Type: 1,
        PayingAuthName: this.payingAuthName,
        PayingAuthBankID: this.bankID,
        PayingAuthAddress: this.pAddress,
        PayingAuthStateID: this.pStateID,
        PayingAuthContactNo: this.pContactNo,
        PayingAuthEmailAddress: this.pEmail,
        PayingAuthDesigID: this.pDesigID,
        PayingAuthPlaceofSupply: this.pPlaceOfSupply,
        PayingAuthCity: this.pCity,
        PayingAuthPinCode: this.pPinCode,
        CaptchaValue: this.captchaValue,
        CaptchaKey: this.captchaKey,

        //=========Contact Person ===================

        contactPersonName: this.contactPersonName,
        contactPersondesigID: this.contactPersondesigID,
        contactPersonDepartment: this.contactPersonDepartment,
        contactPersonMobNoCC: this.contactPersonMobNoCC,
        contactPersonMobNoAC: this.contactPersonMobNoAC,
        contactPersonEmail: this.contactPersonEmail,
        contactPersonAddress: this.contactPersonAddress
      };
      NomAuthJS.SetOnlineMasterAccountData(_data_).then(
        response => {
          // console.log(response.data);
          if (response.data.isSuccess) {
            MessageBox.show({
              message: response.data.msg,
              type: "success",
              title: "Success"
            });
          } else {
            MessageBox.show({
              message: response.data.msg,
              type: "error",
              title: "Error"
            });
          }
          this.confirmationDiv = false;
          this.GetMasterAccountList();
          this.$emit("ChangeNomAuthID", response.data.nomineeID);
          this.$emit("ChangeNominationCode", response.data.nominationCode);
          this.clear();
        },
        error => {
          MessageBox.show({
            message: error,
            type: "error",
            title: "Error"
          });
        }
      );
    },
    SetOnlineNominee(saveAsMaster) {
      const _data_ = {
        ProgID: this.ProgID,
        NomineeID: this.NomineeID,
        BankID: this.bankID,
        BranchName: this.branchName,
        TitleID: this.titleID,
        FirstName: this.fName,
        MiddleName: this.mName,
        LastName: this.lName,
        DesigID: this.desigID,
        ContactNo: this.contactNo,
        AlternateContactNo: this.altContactNo,
        MobileNo: this.mobileNo,
        AlternateMobileNo: this.altMobileNo,
        Email: this.emailID,
        AlternateEmail: this.altEmail,
        Fax: this.faxNo,
        NominationCode: this.refNo,
        ContactNoCC: this.contactCC,
        ContactNoAC: this.contactAC,
        AlternateContactNoCC: this.altContactCC,
        AlternateContactNoAC: this.altContactAC,
        MobileNoCC: this.mobileCC,
        AlternateMobileNoCC: this.altMobileCC,
        FaxCC: this.faxCC,
        FaxAC: this.faxAC,
        Address1: this.address1,
        Address2: this.address2,
        Remark: this.remark,
        Discount: this.discount,
        LetterNo: this.letterNo,
        GSTNo: this.pGSTNo,
        PayingAuthName: this.payingAuthName,
        PayingAuthBankID: this.bankID,
        PayingAuthAddress: this.pAddress,
        PayingAuthStateID: this.pStateID,
        PayingAuthContactNo: this.pContactNo,
        PayingAuthEmailAddress: this.pEmail,
        PayingAuthDesigID: this.pDesigID,
        PayingAuthPlaceofSupply: this.pPlaceOfSupply,
        PayingAuthCity: this.pCity,
        PayingAuthPinCode: this.pPinCode,
        PaymentMode: -1,
        MasterAccountID: this.masterAccountID,
        SaveInMasterAlso: saveAsMaster,
        Type: 1,
        CaptchaValue: this.captchaValue,
        CaptchaKey: this.captchaKey,

        //==========Contact Person=========================
        ContactPersonName: this.contactPersonName,
        ContactPersondesigID: this.contactPersondesigID,
        ContactPersonDepartment: this.contactPersonDepartment,
        ContactPersonMobNoCC: this.contactPersonMobNoCC,
        ContactPersonMobNoAC: this.contactPersonMobNoAC,
        ContactPersonEmail: this.contactPersonEmail,
        ContactPersonaddress: this.contactPersonAddress
      };
      NomAuthJS.SetOnlineNominee(_data_).then(
        response => {
          // console.log(response.data);
          if (response.data.isSuccess) {
            MessageBox.show({
              message: response.data.msg,
              type: "success",
              title: "Success"
            });
          } else {
            MessageBox.show({
              message: response.data.msg,
              type: "error",
              title: "Error"
            });
          }
          this.confirmationDiv = false;
          if (saveAsMaster == 1) {
            this.GetMasterAccountList();
          }
          this.captchaValue = "";
          this.captchaKey = "";
          this.generateCaptcha(1, 110, 21);
          this.$emit("AddORUpdateNomAuth", this.ProgID);
          this.$emit("ChangeNomAuthID", response.data.result);
          this.$emit("ChangeNominationCode", response.data.result1);
        },
        error => {
          MessageBox.show({
            message: error,
            type: "error",
            title: "Error"
          });
        }
      );
    },
    GetMasterAccountList() {
      const _data_ = { loginID: -1, masterAccountID: -1, type: 1 };
      NomAuthJS.GetMasterAccountList(_data_).then(
        response => {
          if (response.data) {
            this.MasterAccount_List = response.data;
            this.generateCaptcha(1, 110, 21);
            // this.GetBank();
            this.GetState();
          }
        },
        error => {}
      );
    },
    clear() {
      this.masterAccountID = -1;
      this.NomineeID = -1;
      this.refNo = "";
      this.titleID = 1;
      this.fName = "";
      this.mName = "";
      this.lName = "";
      this.bankID = -1;
      this.branchName = "";
      this.desigID = -1;
      this.discount = "0";
      this.contactCC = "+91";
      this.contactAC = "";
      this.contactNo = "";
      this.altContactCC = "+91";
      this.altContactAC = "";
      this.mobileCC = "+91";
      this.mobileNo = "";
      this.faxCC = "+91";
      this.faxAC = "";
      this.emailID = "";
      this.altEmail = "";
      this.letterNo = "";
      this.address1 = "";
      this.address2 = "";
      this.remark = "";
      // this.pBankID = -1;
      this.pStateID = -1;
      this.pGSTNo = "";
      this.payingAuthName = "";
      this.pEmail = "";
      this.pContactNo = "";
      this.pDesigID = -1;
      this.pAddress = "";
      this.pPlaceOfSupply = "";
      this.pCity = "";
      this.pPinCode = "";
      this.btnSave = "Save";
      this.btnSaveMs = "Click Here to Save";
      // this.NomAuthID = -1;
      $('input[type="search"]').val("");
      this.$emit("ChangeNomAuthID", this.NomAuthID);
      this.$emit("ChangeNominationCode", "");

      //========Contact Person

      this.contactPersonName = "";
      this.contactPersondesigID = -1;
      this.contactPersonDepartment = "";
      this.contactPersonMobNoCC = "";
      this.contactPersonMobNoAC = "";
      this.contactPersonEmail = "";
      this.contactPersonAddress = "";
    },
    fetchData(row) {
      var nomList = row[0];
      console.log(nomList);
      this.NomineeID = nomList.nomineeID;
      this.refNo = nomList.nominationCode;
      this.titleID = nomList.titleID;
      this.fName = nomList.firstName;
      this.mName = nomList.middleName;
      this.lName = nomList.surName;
      this.bankID = nomList.bankID;
      vue.nextTick(() => {
        this.$root.$emit("callChangeBank", nomList.bankName, nomList.bankID);
      });
      this.branchName = nomList.branchName;
      this.desigID = nomList.desigID;
      vue.nextTick(() => {
        this.$root.$emit("callChange", nomList.desigName, nomList.desigID);
      });
      this.discount = nomList.discount.toString();
      this.contactCC = nomList.contactNoCC;
      this.contactAC = nomList.contactNoAC;
      this.contactNo = nomList.contactNo;
      this.altContactCC = nomList.alternateContactNoCC;
      this.altContactAC = nomList.alternateContactNoAC;
      this.mobileCC = nomList.mobileNoCC;
      this.mobileNo = nomList.mobileNo;
      this.faxCC = nomList.faxCC;
      this.faxAC = nomList.faxAC;
      this.emailID = nomList.email;
      this.altEmail = nomList.alternateEmail;
      this.letterNo = nomList.letterNo;
      this.address1 = nomList.address1;
      this.address2 = nomList.address2;
      this.remark = nomList.remark;
      // this.pBankID = nomList.payingAuthBankID;
      this.pStateID = nomList.payingAuthStateID;
      this.pGSTNo = nomList.gstNo;
      this.payingAuthName = nomList.payingAuthName;
      this.pEmail = nomList.payingAuthEmailAddress;
      this.pContactNo = nomList.payingAuthContactNo;
      this.pDesigID = nomList.payingAuthDesigID;
      vue.nextTick(() => {
        this.$root.$emit(
          "callChangeDesig",
          nomList.payingAuthDesigName,
          nomList.payingAuthDesigID
        );
      });
      this.pAddress = nomList.payingAuthAddress;
      this.pPlaceOfSupply = nomList.payingAuthPlaceofSupply;
      this.pCity = nomList.payingAuthCity;
      this.pPinCode = nomList.payingAuthPinCode;
      this.masterAccountID = nomList.masterAccountID;
      this.btnSave = "Update";
      this.btnSaveMsg = "Click Here to Update";
      this.$emit("ChangeNomAuthID", nomList.nomineeID);
      this.$emit("ChangeNominationCode", nomList.nominationCode);

      //==   Contact Person
      this.contactPersonName = nomList.contactPersonName;
      this.contactPersondesigID = nomList.contactPersondesigID;
      this.contactPersonDepartment = nomList.contactPersonDepartment;
      this.contactPersonMobNoCC = nomList.contactPersonMobNoCC;
      this.contactPersonMobNoAC = nomList.contactPersonMobNoAC;
      this.contactPersonEmail = nomList.contactPersonEmail;
      this.contactPersonAddress = nomList.contactPersonAddress;
    },
    fillMasterData(masterAccountID) {
      if (this.masterAccountID == -1) {
        this.clear();
        // MessageBox.show({
        //   message: "PLEASE SELECT MASTER ACCOUNT",
        //   type: "error",
        //   title: "Error",
        // });
        return;
      }
      var masterAccList = this.MasterAccount_List.filter(item => {
        return item.masterAccountID == masterAccountID;
      })[0];
      this.NomineeID = -1;
      this.refNo = "";
      this.titleID = masterAccList.rankID;
      this.fName = masterAccList.fName;
      this.mName = masterAccList.mName;
      this.lName = masterAccList.lName;
      this.bankID = masterAccList.bankID;
      vue.nextTick(() => {
        this.$root.$emit(
          "callChangeBank",
          masterAccList.bankName,
          masterAccList.bankID
        );
      });
      this.branchName = masterAccList.branchName;
      this.desigID = masterAccList.desigID;
      vue.nextTick(() => {
        this.$root.$emit(
          "callChange",
          masterAccList.desigName,
          masterAccList.desigID
        );
      });
      this.contactCC = masterAccList.contactNoCC;
      this.contactAC = masterAccList.contactNoAC;
      this.contactNo = masterAccList.contactNo;
      this.altContactCC = masterAccList.alternateContactNoCC;
      this.altContactAC = masterAccList.alternateContactNoAC;
      this.discount = "0";
      this.mobileCC = masterAccList.userMobileCC;
      this.mobileNo = masterAccList.userMobile;
      this.faxCC = masterAccList.faxCC;
      this.faxAC = masterAccList.faxAC;
      this.emailID = masterAccList.userEMail;
      this.altEmail = masterAccList.alternateEmail;
      this.letterNo = "";
      this.address1 = masterAccList.address1;
      this.address2 = masterAccList.address2;
      this.remark = "";
      // this.pBankID = masterAccList.payingAuthBankID;
      this.pStateID = masterAccList.payingAuthStateID;
      this.pGSTNo = masterAccList.gstNo;
      this.payingAuthName = masterAccList.payingAuthName;
      this.pEmail = masterAccList.payingAuthEmailAddress;
      this.pContactNo = masterAccList.payingAuthContactNo;
      this.pDesigID = masterAccList.payingAuthDesigID;
      vue.nextTick(() => {
        this.$root.$emit(
          "callChangeDesig",
          masterAccList.payingAuthDesigName,
          masterAccList.payingAuthDesigID
        );
      });
      this.pAddress = masterAccList.payingAuthAddress;
      this.pPlaceOfSupply = masterAccList.payingAuthPlaceofSupply;
      this.pCity = masterAccList.payingAuthCity;
      this.pPinCode = masterAccList.payingAuthPinCode;

      //==   Contact Person
      this.contactPersonName = masterAccList.contactPersonName;
      this.contactPersondesigID = masterAccList.contactPersondesigID;
      this.contactPersonDepartment = masterAccList.contactPersonDepartment;
      this.contactPersonMobCC = masterAccList.contactPersonMobCC;
      this.contactPersonMobNo = masterAccList.contactPersonMobNo;
      this.contactPersonEmail = masterAccList.contactPersonEmail;
      this.contactPersonAddress = masterAccList.contactPersonAddress;
    },
    addEditMaster(type) {
      if (type == 1) {
        this.masterAccountID = -1;
        this.btnSave = "Save As Master";
        this.btnSaveMsg = "Click Here to Save As Master";
      } else {
        this.btnSave = "Update As Master";
        this.btnSaveMsg = "Click Here to Update As Master";
      }
    },
    generateCaptcha(type, w, h) {
      this.captchaValue = "";
      const _data_ = { width: w, height: h };
      LoginJS.GenerateCaptcha(_data_).then(
        response => {
          if (type == 1) {
            $("#imgCaptcha").attr("src", response.data.result1);
            this.captchaKey = response.data.result;
          }
        },
        error => {
          if (error.response.data.message != undefined) {
            alert(
              error.response.data.message +
                "\n" +
                error.response.data.exceptionMessage
            );
          } else {
            alert("Error: " + error.response.data);
          }
        },
        failure => {
          alert("Failure: " + failure.response);
        }
      );
    }
  },
  computed: {},
  watch: {
    Nomination_List(newValue, oldValue) {
      this.fetchData(this.NomAuthList);
    }
  },
  mounted() {
    if (this.NomAuthID != -1) {
      this.Nomination_List = this.NomAuthList;
    }
    this.GetMasterAccountList();
  }
};
</script>
<style scoped>
.instruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 10px;
  border-radius: 5px;
  min-height: 30px;
  line-height: 30px;
  font-size: small;
  margin-bottom: 6px;
  border-bottom: solid thin darkgrey;
}
.payinstruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 5px;
  border-radius: 5px;
  min-height: 20px;
  line-height: 20px;
  font-size: inherit;
  margin-bottom: 6px;
  /* border-bottom: solid thin darkgrey; */
}
.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  box-shadow: 3px 1px 4px;
  background-color: white;
  color: Black;
}
.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  box-shadow: 3px 1px 4px black;
  border-bottom: solid 2px black;
  cursor: pointer;
  color: white;
}
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.docfileImg {
  height: 50px;
  width: 50px;
}
.popbounce-enter-active {
  animation: popbounce-in 0.5s;
}
.popbounce-leave-active {
  animation: popbounce-in 0.4s reverse;
}
@keyframes popbounce-in {
  0% {
    transform: scale(0);
  }
  25% {
    transform: scale(0.25);
  }
  50% {
    transform: scale(0.5);
  }
  75% {
    transform: scale(0.75);
  }
  100% {
    transform: scale(1);
  }
}
.backgroundPopup {
  position: fixed;
  _position: absolute; /* hack for internet explorer 6*/
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: #000000;
  border: 1px solid #cecece;
  z-index: 1;
  opacity: 0.5;
}
.PopUpCover {
  width: 450px;
  border: solid 1px;
  border-radius: 4px;
  top: 200px;
  position: absolute;
  min-height: 256px;
  right: 450px;
  background-color: rgba(255, 248, 248, 0.86); /*rgb(223, 223, 223);*/
  box-shadow: 1px 1px 20px 1px White;
  border-radius: 18px 18px 18px 18px;
  z-index: 2;
  color: black !important;
}
.PopUpDetail {
  padding: 3px;
  min-height: 200px;
  max-height: 400px;
  overflow: auto;
}
.PopUpHeader {
  padding: 5px !important;
  font-size: 13pt;
  min-height: 30px;
  border-bottom: solid 1px;
}
.PopClose {
  line-height: 18px;
  right: 2px;
  top: 3px;
  position: absolute;
  color: white;
  font-weight: 700;
  display: block;
  padding: 5px;
  background-color: rgba(255, 0, 0, 0.94);
  border-radius: 6px;
  cursor: pointer;
  width: 28px;
  text-align: center;
}
.drop_area {
  height: 60px;
  background-color: antiquewhite;
  margin: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  line-height: 60px;
}
.file_drop {
  font-size: small;
}
.preview_content {
  background-color: lightblue;
  border-radius: 3px;
  margin: 3px;
  min-height: 177px;
  width: 99%;
  overflow: auto;
  padding: 8px;
  border-radius: 1px 1px 20px 20px;
}
.file_column {
  align-content: center;
  text-align: center;
  float: left;
  width: 25%;
  position: relative;
  /* border: solid thin;
                border-radius: 8px; */
  margin-left: 10px;
}
.file_row:after {
  content: "";
  display: table;
  clear: both;
}
.del_img {
  border-radius: 15px;
  cursor: pointer;
  padding: 5px 5px 5px 5px;
  background-color: rgb(255, 0, 0);
  color: White;
  font-weight: bold;
  position: absolute;
  right: -12px;
  z-index: 5001;
}
.del_img:hover {
  background-color: #fb0bbf;
}
.preview_div {
  align-content: center;
  text-align: center;
  height: 100px;
  width: 110px;
  margin: 2px;
  cursor: pointer;
  border: solid thin darkgray;
  border-radius: 10px;
  background-color: rgba(133, 236, 236, 0.15);
}
.percent_div {
  color: #f3dbdb;
  font-weight: bold;
  align-content: center;
  text-align: center;
  width: 100%;
}
.file_preview {
  height: 80px;
  width: 80px;
}
.file_name {
  font-size: 11px;
  text-overflow: ellipsis;
  width: calc(80%);
  display: inline-block;
  /* color: #f3dbdb; */
}
.file_count {
  margin-top: 5px;
  margin-left: 5px;
  vertical-align: middle;
  padding: 0px 3px 3px 3px;
  font-size: small;
  font-weight: bold;
  font-family: Tahoma;
  background-color: rgba(255, 255, 255, 0.41);
  color: Black;
  border: 1px dashed #ccc;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
.error_upload {
  background-color: red;
}
.profileDiv {
  height: 170px;
  width: 180px;
}
.signatureDiv {
  height: 170px;
  width: 300px;
}
.profileImg {
  height: 100%;
  width: 100%;
  border-radius: 10px;
  box-shadow: 5px -4px 5px #807878;
  border-left: solid thin;
  border-bottom: solid thin;
}
.AppHeader {
  border: solid thin gainsboro;
  border-radius: 5px;
  min-height: 55px;
  font-size: medium;
  font-weight: bold;
}
.paymentLabels {
  color: black;
  font-weight: bold;
  font-size: medium;
  text-align: left;
}
.paymentLabels > .Flex_Row {
  border-bottom: solid thin ghostwhite;
}
fieldset {
  margin-bottom: 4px !important;
}
.childSaveTable {
  width: 98%;
  margin-left: 10px;
}
.myhead::-webkit-scrollbar {
  background-color: transparent;
}
.myhead::scrollbar {
  background-color: transparent;
}
.Green {
  background-color: greenyellow;
  display: block;
  font-weight: 600;
}
.appNoClass {
  display: inline-block;
  border: solid thin;
  padding: 5px 5px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  /* font-family: verdana; 
                box-shadow: 1px 1px 4px 2px darkgrey;*/
  margin: 0px !important;
  width: 95%;
}
.appNoClass:hover {
  background-color: darkorange;
}
.hidenShowClass {
  display: inline-block;
  border: solid thin;
  padding: 2px 5px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  /* font-family: verdana; */
  -webkit-box-shadow: 1px 1px 4px 2px darkgrey;
  box-shadow: 1px 1px 4px 2px darkgrey;
  right: 34px;
  position: absolute;
}
.hidenShowClass:hover {
  background-color: darkorange;
}
.myIconButton {
  padding: 0px;
}
.myIconButton a.glyphicons:before {
  font-size: 21px;
  cursor: pointer;
}
.Multibutton {
  padding: 0px;
}
.Multibutton a.glyphicons:before {
  font-size: 18px;
  cursor: pointer;
  margin-top: -2px;
  display: block;
}
.blackColor {
  color: black;
}
.redColor {
  color: red;
}
.DropDownHeigh {
  height: 27px;
  line-height: 22px;
}
.RowHeight {
  min-height: 29px;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divApplication {
  margin-left: 4px;
  margin-right: 5px;
  border: dotted 1px darkgray;
  border-radius: 5px;
  padding: 5px 0px 0px 5px;
}
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(200px);
  opacity: 0;
}
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
.tblEntryForm > .Flex_Row {
  display: flex;
  flex-wrap: wrap;
}
/* .tblEntryForm > .Flex_Row > .Flex_Cell {
            width: 25% !important;
        } */

@media screen and (max-width: 800px) {
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
}
</style>

<style scoped>
.CountryCode {
}
.ddlFlag {
  position: relative;
  cursor: pointer;
}
.ddlFlag .Flag {
  width: 16px;
  height: 14px;
  position: absolute;
  top: 3px;
  left: 7px;
  background: url("../assets/images/flags16_2.png") no-repeat;
}
.Flag.in {
  background-position: 0 -1856px;
}
.ddlArrow {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid black;
  width: 0px;
  height: 0px;
  position: absolute;
  left: 18px;
  top: 5px;
}
.ddlFlag .ddlCountryCodes {
  display: none;
  position: absolute;
  border: solid 1px black;
  background-color: White;
  top: 22px;
  left: 3px;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
  position: absolute;
  z-index: 1;
}
.ddlFlag .ddlCountryCodes .ulCountryCodes {
  list-style: outside none none;
  max-height: 250px;
  width: 330px;
  overflow-y: scroll;
  margin: 0;
  padding: 0;
}
.ddlFlag .ddlCountryCodes.Open {
  display: block;
}
.ddlFlag .ddlCountryCodes .txtSearchCountry {
  width: calc(100% - 20px);
  border: solid 1px rgb(150, 150, 150);
  border-radius: 10px;
  padding: 5px 10px;
}
.ddlFlag .ddlCountryCodes .ulCountryCodes .Country {
  line-height: 16px;
  padding: 4px 0px;
  cursor: pointer;
  border: solid 1px White;
}
.ddlFlag .ddlCountryCodes .ulCountryCodes .Country:hover {
  border: solid 1px black;
  background-color: rgba(0, 0, 255, 0.1);
}
.ddlFlag .ddlCountryCodes .ulCountryCodes .Country.Selected {
  background-color: rgba(0, 0, 255, 0.4);
}
.ddlFlag .ddlCountryCodes .ulCountryCodes .Country .Flag {
  position: relative;
  display: inline-block;
  margin-right: 12px;
}
.ddlFlag .ddlCountryCodes .ulCountryCodes .Country .CountryName {
  color: Black;
}
.ddlFlag .ddlCountryCodes .ulCountryCodes .Country .CountryCode {
  color: Gray;
  margin-left: 5px;
}

/*-----Country Code Flag Images Position*/

.ddlFlag ._African_Union {
  background-position: 0 -16px;
}
.ddlFlag ._Arab_League {
  background-position: 0 -32px;
}
.ddlFlag ._ASEAN {
  background-position: 0 -48px;
}
.ddlFlag ._CARICOM {
  background-position: 0 -64px;
}
.ddlFlag ._CIS {
  background-position: 0 -80px;
}
.ddlFlag ._Commonwealth {
  background-position: 0 -96px;
}
.ddlFlag ._England {
  background-position: 0 -112px;
}
.ddlFlag ._European_Union {
  background-position: 0 -128px;
}
.ddlFlag ._Islamic_Conference {
  background-position: 0 -144px;
}
.ddlFlag ._Kosovo {
  background-position: 0 -160px;
}
.ddlFlag ._NATO {
  background-position: 0 -176px;
}
.ddlFlag ._Northern_Cyprus {
  background-position: 0 -192px;
}
.ddlFlag ._Northern_Ireland {
  background-position: 0 -208px;
}
.ddlFlag ._Olimpic_Movement {
  background-position: 0 -224px;
}
.ddlFlag ._OPEC {
  background-position: 0 -240px;
}
.ddlFlag ._Red_Cross {
  background-position: 0 -256px;
}
.ddlFlag ._Scotland {
  background-position: 0 -272px;
}
.ddlFlag ._Somaliland {
  background-position: 0 -288px;
}
.ddlFlag ._Tibet {
  background-position: 0 -304px;
}
.ddlFlag ._United_Nations {
  background-position: 0 -320px;
}
.ddlFlag ._Wales {
  background-position: 0 -336px;
}
.ddlFlag .ad {
  background-position: 0 -352px;
}
.ddlFlag .ae {
  background-position: 0 -368px;
}
.ddlFlag .af {
  background-position: 0 -384px;
}
.ddlFlag .ag {
  background-position: 0 -400px;
}
.ddlFlag .ai {
  background-position: 0 -416px;
}
.ddlFlag .al {
  background-position: 0 -432px;
}
.ddlFlag .am {
  background-position: 0 -448px;
}
.ddlFlag .an {
  background-position: 0 -464px;
}
.ddlFlag .ao {
  background-position: 0 -480px;
}
.ddlFlag .aq {
  background-position: 0 -496px;
}
.ddlFlag .ar {
  background-position: 0 -512px;
}
.ddlFlag .as {
  background-position: 0 -528px;
}
.ddlFlag .at {
  background-position: 0 -544px;
}
.ddlFlag .au {
  background-position: 0 -560px;
}
.ddlFlag .aw {
  background-position: 0 -576px;
}
.ddlFlag .az {
  background-position: 0 -592px;
}
.ddlFlag .ba {
  background-position: 0 -608px;
}
.ddlFlag .bb {
  background-position: 0 -624px;
}
.ddlFlag .bd {
  background-position: 0 -640px;
}
.ddlFlag .be {
  background-position: 0 -656px;
}
.ddlFlag .bf {
  background-position: 0 -672px;
}
.ddlFlag .bg {
  background-position: 0 -688px;
}
.ddlFlag .bh {
  background-position: 0 -704px;
}
.ddlFlag .bi {
  background-position: 0 -720px;
}
.ddlFlag .bj {
  background-position: 0 -736px;
}
.ddlFlag .bm {
  background-position: 0 -752px;
}
.ddlFlag .bn {
  background-position: 0 -768px;
}
.ddlFlag .bo {
  background-position: 0 -784px;
}
.ddlFlag .br {
  background-position: 0 -800px;
}
.ddlFlag .bs {
  background-position: 0 -816px;
}
.ddlFlag .bt {
  background-position: 0 -832px;
}
.ddlFlag .bw {
  background-position: 0 -848px;
}
.ddlFlag .by {
  background-position: 0 -864px;
}
.ddlFlag .bz {
  background-position: 0 -880px;
}
.ddlFlag .ca {
  background-position: 0 -896px;
}
.ddlFlag .cg {
  background-position: 0 -912px;
}
.ddlFlag .cf {
  background-position: 0 -928px;
}
.ddlFlag .cd {
  background-position: 0 -944px;
}
.ddlFlag .ch {
  background-position: 0 -960px;
}
.ddlFlag .ci {
  background-position: 0 -976px;
}
.ddlFlag .ck {
  background-position: 0 -992px;
}
.ddlFlag .cl {
  background-position: 0 -1008px;
}
.ddlFlag .cm {
  background-position: 0 -1024px;
}
.ddlFlag .cn {
  background-position: 0 -1040px;
}
.ddlFlag .co {
  background-position: 0 -1056px;
}
.ddlFlag .cr {
  background-position: 0 -1072px;
}
.ddlFlag .cu {
  background-position: 0 -1088px;
}
.ddlFlag .cv {
  background-position: 0 -1104px;
}
.ddlFlag .cy {
  background-position: 0 -1120px;
}
.ddlFlag .cz {
  background-position: 0 -1136px;
}
.ddlFlag .de {
  background-position: 0 -1152px;
}
.ddlFlag .dj {
  background-position: 0 -1168px;
}
.ddlFlag .dk {
  background-position: 0 -1184px;
}
.ddlFlag .dm {
  background-position: 0 -1200px;
}
.ddlFlag .do {
  background-position: 0 -1216px;
}
.ddlFlag .dz {
  background-position: 0 -1232px;
}
.ddlFlag .ec {
  background-position: 0 -1248px;
}
.ddlFlag .ee {
  background-position: 0 -1264px;
}
.ddlFlag .eg {
  background-position: 0 -1280px;
}
.ddlFlag .eh {
  background-position: 0 -1296px;
}
.ddlFlag .er {
  background-position: 0 -1312px;
}
.ddlFlag .es {
  background-position: 0 -1328px;
}
.ddlFlag .et {
  background-position: 0 -1344px;
}
.ddlFlag .fi {
  background-position: 0 -1360px;
}
.ddlFlag .fj {
  background-position: 0 -1376px;
}
.ddlFlag .fm {
  background-position: 0 -1392px;
}
.ddlFlag .fo {
  background-position: 0 -1408px;
}
.ddlFlag .fr {
  background-position: 0 -1424px;
}
.ddlFlag .ga {
  background-position: 0 -1440px;
}
.ddlFlag .gb {
  background-position: 0 -1456px;
}
.ddlFlag .gd {
  background-position: 0 -1472px;
}
.ddlFlag .ge {
  background-position: 0 -1488px;
}
.ddlFlag .gg {
  background-position: 0 -1504px;
}
.ddlFlag .gh {
  background-position: 0 -1520px;
}
.ddlFlag .gi {
  background-position: 0 -1536px;
}
.ddlFlag .gl {
  background-position: 0 -1552px;
}
.ddlFlag .gm {
  background-position: 0 -1568px;
}
.ddlFlag .gn {
  background-position: 0 -1584px;
}
.ddlFlag .gp {
  background-position: 0 -1600px;
}
.ddlFlag .gq {
  background-position: 0 -1616px;
}
.ddlFlag .gr {
  background-position: 0 -1632px;
}
.ddlFlag .gt {
  background-position: 0 -1648px;
}
.ddlFlag .gu {
  background-position: 0 -1664px;
}
.ddlFlag .gw {
  background-position: 0 -1680px;
}
.ddlFlag .gy {
  background-position: 0 -1696px;
}
.ddlFlag .hk {
  background-position: 0 -1712px;
}
.ddlFlag .hn {
  background-position: 0 -1728px;
}
.ddlFlag .hr {
  background-position: 0 -1744px;
}
.ddlFlag .ht {
  background-position: 0 -1760px;
}
.ddlFlag .hu {
  background-position: 0 -1776px;
}
.ddlFlag .id {
  background-position: 0 -1792px;
}
.ddlFlag .mc {
  background-position: 0 -1792px;
}
.ddlFlag .ie {
  background-position: 0 -1808px;
}
.ddlFlag .il {
  background-position: 0 -1824px;
}
.ddlFlag .im {
  background-position: 0 -1840px;
}
.ddlFlag .in {
  background-position: 0 -1856px;
}
.ddlFlag .iq {
  background-position: 0 -1872px;
}
.ddlFlag .ir {
  background-position: 0 -1888px;
}
.ddlFlag .is {
  background-position: 0 -1904px;
}
.ddlFlag .it {
  background-position: 0 -1920px;
}
.ddlFlag .je {
  background-position: 0 -1936px;
}
.ddlFlag .jm {
  background-position: 0 -1952px;
}
.ddlFlag .jo {
  background-position: 0 -1968px;
}
.ddlFlag .jp {
  background-position: 0 -1984px;
}
.ddlFlag .ke {
  background-position: 0 -2000px;
}
.ddlFlag .kg {
  background-position: 0 -2016px;
}
.ddlFlag .kh {
  background-position: 0 -2032px;
}
.ddlFlag .ki {
  background-position: 0 -2048px;
}
.ddlFlag .km {
  background-position: 0 -2064px;
}
.ddlFlag .kn {
  background-position: 0 -2080px;
}
.ddlFlag .kp {
  background-position: 0 -2096px;
}
.ddlFlag .kr {
  background-position: 0 -2112px;
}
.ddlFlag .kw {
  background-position: 0 -2128px;
}
.ddlFlag .ky {
  background-position: 0 -2144px;
}
.ddlFlag .kz {
  background-position: 0 -2160px;
}
.ddlFlag .la {
  background-position: 0 -2176px;
}
.ddlFlag .lb {
  background-position: 0 -2192px;
}
.ddlFlag .lc {
  background-position: 0 -2208px;
}
.ddlFlag .li {
  background-position: 0 -2224px;
}
.ddlFlag .lk {
  background-position: 0 -2240px;
}
.ddlFlag .lr {
  background-position: 0 -2256px;
}
.ddlFlag .ls {
  background-position: 0 -2272px;
}
.ddlFlag .lt {
  background-position: 0 -2288px;
}
.ddlFlag .lu {
  background-position: 0 -2304px;
}
.ddlFlag .lv {
  background-position: 0 -2320px;
}
.ddlFlag .ly {
  background-position: 0 -2336px;
}
.ddlFlag .ma {
  background-position: 0 -2352px;
}
.ddlFlag .md {
  background-position: 0 -2368px;
}
.ddlFlag .me {
  background-position: 0 -2384px;
}
.ddlFlag .mg {
  background-position: 0 -2400px;
}
.ddlFlag .mh {
  background-position: 0 -2416px;
}
.ddlFlag .mk {
  background-position: 0 -2432px;
}
.ddlFlag .ml {
  background-position: 0 -2448px;
}
.ddlFlag .mm {
  background-position: 0 -2464px;
}
.ddlFlag .mn {
  background-position: 0 -2480px;
}
.ddlFlag .mo {
  background-position: 0 -2496px;
}
.ddlFlag .mq {
  background-position: 0 -2512px;
}
.ddlFlag .mr {
  background-position: 0 -2528px;
}
.ddlFlag .ms {
  background-position: 0 -2544px;
}
.ddlFlag .mt {
  background-position: 0 -2560px;
}
.ddlFlag .mu {
  background-position: 0 -2576px;
}
.ddlFlag .mv {
  background-position: 0 -2592px;
}
.ddlFlag .mw {
  background-position: 0 -2608px;
}
.ddlFlag .mx {
  background-position: 0 -2624px;
}
.ddlFlag .my {
  background-position: 0 -2640px;
}
.ddlFlag .mz {
  background-position: 0 -2656px;
}
.ddlFlag .na {
  background-position: 0 -2672px;
}
.ddlFlag .nc {
  background-position: 0 -2688px;
}
.ddlFlag .ne {
  background-position: 0 -2704px;
}
.ddlFlag .ng {
  background-position: 0 -2720px;
}
.ddlFlag .ni {
  background-position: 0 -2736px;
}
.ddlFlag .nl {
  background-position: 0 -2752px;
}
.ddlFlag .no {
  background-position: 0 -2768px;
}
.ddlFlag .np {
  background-position: 0 -2784px;
}
.ddlFlag .nr {
  background-position: 0 -2800px;
}
.ddlFlag .nz {
  background-position: 0 -2816px;
}
.ddlFlag .om {
  background-position: 0 -2832px;
}
.ddlFlag .pa {
  background-position: 0 -2848px;
}
.ddlFlag .pe {
  background-position: 0 -2864px;
}
.ddlFlag .pf {
  background-position: 0 -2880px;
}
.ddlFlag .pg {
  background-position: 0 -2896px;
}
.ddlFlag .ph {
  background-position: 0 -2912px;
}
.ddlFlag .pk {
  background-position: 0 -2928px;
}
.ddlFlag .pl {
  background-position: 0 -2944px;
}
.ddlFlag .pr {
  background-position: 0 -2960px;
}
.ddlFlag .ps {
  background-position: 0 -2976px;
}
.ddlFlag .pt {
  background-position: 0 -2992px;
}
.ddlFlag .pw {
  background-position: 0 -3008px;
}
.ddlFlag .py {
  background-position: 0 -3024px;
}
.ddlFlag .qa {
  background-position: 0 -3040px;
}
.ddlFlag .re {
  background-position: 0 -3056px;
}
.ddlFlag .ro {
  background-position: 0 -3072px;
}
.ddlFlag .rs {
  background-position: 0 -3088px;
}
.ddlFlag .ru {
  background-position: 0 -3104px;
}
.ddlFlag .rw {
  background-position: 0 -3120px;
}
.ddlFlag .sa {
  background-position: 0 -3136px;
}
.ddlFlag .sb {
  background-position: 0 -3152px;
}
.ddlFlag .sc {
  background-position: 0 -3168px;
}
.ddlFlag .sd {
  background-position: 0 -3184px;
}
/*New South Sudan added at the end of all country flags -3888px + 16px*/
.ddlFlag .ssd {
  background-position: 0 -3904px;
}
.ddlFlag .se {
  background-position: 0 -3200px;
}
.ddlFlag .sg {
  background-position: 0 -3216px;
}
.ddlFlag .si {
  background-position: 0 -3232px;
}
.ddlFlag .sk {
  background-position: 0 -3248px;
}
.ddlFlag .sl {
  background-position: 0 -3264px;
}
.ddlFlag .sm {
  background-position: 0 -3280px;
}
.ddlFlag .sn {
  background-position: 0 -3296px;
}
.ddlFlag .so {
  background-position: 0 -3312px;
}
.ddlFlag .sr {
  background-position: 0 -3328px;
}
.ddlFlag .st {
  background-position: 0 -3344px;
}
.ddlFlag .sv {
  background-position: 0 -3360px;
}
.ddlFlag .sy {
  background-position: 0 -3376px;
}
.ddlFlag .sz {
  background-position: 0 -3392px;
}
.ddlFlag .tc {
  background-position: 0 -3408px;
}
.ddlFlag .td {
  background-position: 0 -3424px;
}
.ddlFlag .tg {
  background-position: 0 -3440px;
}
.ddlFlag .th {
  background-position: 0 -3456px;
}
.ddlFlag .tj {
  background-position: 0 -3472px;
}
.ddlFlag .tl {
  background-position: 0 -3488px;
}
.ddlFlag .tm {
  background-position: 0 -3504px;
}
.ddlFlag .tn {
  background-position: 0 -3520px;
}
.ddlFlag .to {
  background-position: 0 -3536px;
}
.ddlFlag .tr {
  background-position: 0 -3552px;
}
.ddlFlag .tt {
  background-position: 0 -3568px;
}
.ddlFlag .tv {
  background-position: 0 -3584px;
}
.ddlFlag .tw {
  background-position: 0 -3600px;
}
.ddlFlag .tz {
  background-position: 0 -3616px;
}
.ddlFlag .ua {
  background-position: 0 -3632px;
}
.ddlFlag .ug {
  background-position: 0 -3648px;
}
.ddlFlag .us {
  background-position: 0 -3664px;
}
.ddlFlag .uy {
  background-position: 0 -3680px;
}
.ddlFlag .uz {
  background-position: 0 -3696px;
}
.ddlFlag .va {
  background-position: 0 -3712px;
}
.ddlFlag .vc {
  background-position: 0 -3728px;
}
.ddlFlag .ve {
  background-position: 0 -3744px;
}
.ddlFlag .vg {
  background-position: 0 -3760px;
}
.ddlFlag .vi {
  background-position: 0 -3776px;
}
.ddlFlag .vn {
  background-position: 0 -3792px;
}
.ddlFlag .vu {
  background-position: 0 -3808px;
}
.ddlFlag .ws {
  background-position: 0 -3824px;
}
.ddlFlag .ye {
  background-position: 0 -3840px;
}
.ddlFlag .za {
  background-position: 0 -3856px;
}
.ddlFlag .zm {
  background-position: 0 -3872px;
}
.ddlFlag .zw {
  background-position: 0 -3888px;
}
</style>



// WEBPACK FOOTER //
// src/components/NominatingAuth.vue